const semanticClassNames = {
  root: 'text-marquee',
  text: 'text-marquee__text',
} as const;

export default semanticClassNames;
